/**
 * Maximum zoom for the coverage-beta *photo* views — the query shelf image and
 * the reference images. react-zoom-pan-pinch defaults to 8x, which labelers hit
 * before small facings (price tags, tiny SKUs) are readable, so we lift the
 * ceiling well past that.
 *
 * Every zoom path clamps to the wrapper's `maxScale` (wheel, the +/- hotkeys via
 * `zoomAtPointer`, and the toolbar zoom buttons' `zoomIn`/`zoomOut`), so setting
 * it on the TransformWrapper is enough to raise all of them at once.
 *
 * Raising it is safe for the detection boxes: their outlines are sized from the
 * box's on-screen dimensions, not in px the transform can multiply. See
 * `coverage-beta-box-outline`.
 *
 * The planogram is deliberately not covered here — it renders through the
 * ui-components planogram viewer, which manages its own zoom limits.
 */
export const COVERAGE_BETA_MAX_IMAGE_ZOOM = 100;
